/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WorkshopCheckInCDKCheckInCreateModel } from '../models/WorkshopCheckInCDKCheckInCreateModel';
import type { WorkshopCheckInCDKCheckOutCreateModel } from '../models/WorkshopCheckInCDKCheckOutCreateModel';
import type { WorkshopCheckInCDKDetailsModel } from '../models/WorkshopCheckInCDKDetailsModel';
import type { WorkshopCheckInColDelSubmitModel } from '../models/WorkshopCheckInColDelSubmitModel';
import type { WorkshopCheckInCustomerDetailsModel } from '../models/WorkshopCheckInCustomerDetailsModel';
import type { WorkshopCheckInDetailedModel } from '../models/WorkshopCheckInDetailedModel';
import type { WorkshopCheckInLogModelPagedListData } from '../models/WorkshopCheckInLogModelPagedListData';
import type { WorkshopCheckInLookupModel } from '../models/WorkshopCheckInLookupModel';
import type { WorkshopCheckInRegNoLookupModel } from '../models/WorkshopCheckInRegNoLookupModel';
import type { WorkshopCheckInSubmitModel } from '../models/WorkshopCheckInSubmitModel';
import type { WorkshopCheckInUpdateModel } from '../models/WorkshopCheckInUpdateModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkshopCheckInService {

  /**
   * @param branchId 
   * @param dateFrom 
   * @param dateTo 
   * @param regNo 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns WorkshopCheckInLogModelPagedListData Success
   * @throws ApiError
   */
  public static getWorkshopCheckIn(
branchId: number,
dateFrom: string,
dateTo: string,
regNo?: string,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<WorkshopCheckInLogModelPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop-check-in',
      query: {
        'BranchId': branchId,
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'RegNo': regNo,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postWorkshopCheckIn(
requestBody?: WorkshopCheckInSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop-check-in',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postWorkshopCheckInCollectionDelivery(
requestBody?: WorkshopCheckInColDelSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop-check-in/collection-delivery',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param regNo 
   * @returns WorkshopCheckInRegNoLookupModel Success
   * @throws ApiError
   */
  public static getWorkshopCheckInRegnoLookup(
regNo?: string,
): CancelablePromise<Array<WorkshopCheckInRegNoLookupModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop-check-in/regno-lookup',
      query: {
        'regNo': regNo,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param wip 
   * @param regNo 
   * @param branchId 
   * @param activeOnly 
   * @returns WorkshopCheckInLookupModel Success
   * @throws ApiError
   */
  public static getWorkshopCheckInWipLookup(
wip?: number,
regNo?: string,
branchId?: number,
activeOnly?: boolean,
): CancelablePromise<WorkshopCheckInLookupModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop-check-in/wip-lookup',
      query: {
        'wip': wip,
        'regNo': regNo,
        'branchId': branchId,
        'activeOnly': activeOnly,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns WorkshopCheckInDetailedModel Success
   * @throws ApiError
   */
  public static getWorkshopCheckIn1(
id: number,
): CancelablePromise<WorkshopCheckInDetailedModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workshop-check-in/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putWorkshopCheckIn(
id: number,
requestBody?: WorkshopCheckInUpdateModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workshop-check-in/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteWorkshopCheckIn(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/workshop-check-in/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postWorkshopCheckInCustomerDetails(
requestBody?: WorkshopCheckInCustomerDetailsModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop-check-in/customer-details',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postWorkshopCheckInPhoto(
id: number,
formData?: {
files?: Array<Blob>;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop-check-in/{id}/photo',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param photo 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteWorkshopCheckInPhoto(
id: number,
photo: string,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/workshop-check-in/{id}/photo/{photo}',
      path: {
        'id': id,
        'photo': photo,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns string Created
   * @throws ApiError
   */
  public static postWorkshopCheckInVideo(
id: number,
formData?: {
ContentType?: string;
ContentDisposition?: string;
Headers?: Record<string, Array<string>>;
Length?: number;
Name?: string;
FileName?: string;
},
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop-check-in/{id}/video',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteWorkshopCheckInVideo(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/workshop-check-in/{id}/video',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postWorkshopCheckInCdkCheckIn(
id: number,
requestBody?: WorkshopCheckInCDKCheckInCreateModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop-check-in/{id}/cdk-check-in',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postWorkshopCheckInCdkCheckOut(
id: number,
requestBody?: WorkshopCheckInCDKCheckOutCreateModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop-check-in/{id}/cdk-check-out',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postWorkshopCheckInCdkDetails(
id: number,
requestBody?: WorkshopCheckInCDKDetailsModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workshop-check-in/{id}/cdk-details',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
